import { useState, useEffect } from "react";
import TableTop from "../TableComponents/TableTop";
import { Table, TableBody, TablePagination } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getPartOffers } from "../../../reduxStore/entities/userCars";
import PartOffersTableHead from "../TableHeads/PartOffersTableHead";
import PartOffersTableRow from "../TableRows/PartOffersTableRow";
import { handleChangePage, handleChangeRowsPerPage } from "../../../../SharedComponents/utils/helpers/tableHelpers";
import { TableTopTypeEnum } from "../../../utils/enums/TableTopTypeEnum";

const PartOffersTable = ({
    partRequestId
}) => {
    const DEFAULT_ROWS_PER_PAGE = 15;

    const dispatch = useDispatch();

    const [loaded, setLoaded] = useState(false);

    const fetchedPartOffers = useSelector((state) => state.userCars.partOffers);
    const count = useSelector((state) => state.userCars.partOffersCount);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_ROWS_PER_PAGE);

    const filterDto = {
        partRequestId: partRequestId,
        limit: rowsPerPage,
        offset: page * rowsPerPage,
    };

    const [filter, setFilter] = useState(filterDto);

    useEffect(() => {
        setFilter(filterDto);
    }, [page, rowsPerPage]);

    useEffect(() => {
        dispatch(getPartOffers(filter));
    }, [filter]);

    useEffect(() => {
        setLoaded(true);
    }, [fetchedPartOffers]);

    if (!loaded) {
        return null;
    };

    const hasRows = (count > 0);

    return (
        <div>
            <TableTop
                title={"Sve ponude"}
                count={count}
                variant={TableTopTypeEnum.TRANSPARENT}
            />

            {hasRows && (
                <div>
                    <Table>
                        <PartOffersTableHead />

                        <TableBody>

                            {fetchedPartOffers.map((row, index) => (
                                <PartOffersTableRow
                                    key={index}
                                    partOffer={row}
                                />
                            ))}

                        </TableBody>

                    </Table>

                    <TablePagination
                        rowsPerPageOptions={[15, 25, 50]}
                        component="div"
                        count={count}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={(event, newPage) => {
                            handleChangePage(event, newPage, setPage)
                        }}
                        onRowsPerPageChange={(event) => {
                            handleChangeRowsPerPage(
                                event,
                                setRowsPerPage,
                                setPage
                            )
                        }}
                    />
                </div>
            )}
        </div>
    );
};


export default PartOffersTable;